import { EncashmentsStatusType } from 'app/dataTypes/reports/data'
import colors from './statusColor.module.scss'

export const getStatusColor = (status: EncashmentsStatusType | null) => {
  if (status === EncashmentsStatusType.WaitingForCash) return colors.warningColor
  if (status === EncashmentsStatusType.CashAccepted) return colors.successColor
  if (status === EncashmentsStatusType.CashRefused) return colors.errorColor
  if (status === EncashmentsStatusType.CashNotDeposited) return colors.grayColor
  return '#616161'
}
